import { Separator } from '@/components/atoms/Separator';
import { Skeleton } from '@/components/atoms/Skeleton';
import GiftCardValoresGridFallback from '@/components/molecules/GiftCardValoresGrid/fallback';
import PaginaVendaMobileFallback, {
  CheckoutContainerFallback,
} from '@/components/templates/PaginaVendaMobileTemplate/fallback';
import { theme } from '@/styles/theme';
import { Fragment } from 'react';

export default function ProdutoPaginaMobileFallback() {
  return (
    <Fragment>
      <PaginaVendaMobileFallback
        $fallbackConteudoDescritivo={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: theme.spacing[4],
              gap: theme.spacing[5],
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: `${theme.spacing[2]}px 0px`,
                gap: theme.spacing['4'],
              }}
            >
              <Skeleton style={{ height: 20, width: 140 }} />
              <GiftCardValoresGridFallback />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Skeleton style={{ height: 25, width: 100 }} />
              <Skeleton style={{ height: 34, width: 116 }} />
            </div>
            <Separator $block={false} $orientation="horizontal" />
            <Skeleton style={{ height: 200 }} />
          </div>
        }
      />
      <CheckoutContainerFallback />
    </Fragment>
  );
}
